import { getControlItem, setVolume, toggleVolume } from '../utils/helpers'
import { BUTTON_ICON_CLASS, CONTROL_CLASS } from '../utils/videoplayer-constants'
import { Controls } from './controls'

export class Volume extends Controls {
  private wrapperVolumeElement: HTMLElement

  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    super(element, videoPlayer, wrapperElement)
    this.renderVolumeControl()
  }

  private renderVolumeControl() {
    this.renderVolumeWrapper()
    this.renderVolumeSlider()
    this.renderVolumeButton()
  }

  private renderVolumeWrapper() {
    this.wrapperVolumeElement = this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'div',
          classes: ['cmp-video-wrapper__controls-volume-wrapper'],
          attributes: {
            ['data-prev-value']: '100',
          },
        },
      }),
    )
  }

  private renderVolumeButton() {
    this.wrapperVolumeElement.appendChild(
      getControlItem({
        parent: {
          element: 'input',
          classes: ['cmp-input__range-volume'],
          attributes: {
            type: 'range',
            min: '0',
            max: '100',
            value: '100',
            step: '1',
          },
        },
        eventListeners: ['input', 'change'],
        callback: e => setVolume(e, this.videoPlayer, this.wrapperVolumeElement),
      }),
    )
  }

  private renderVolumeSlider() {
    this.wrapperVolumeElement.appendChild(
      getControlItem({
        parent: {
          element: 'button',
          classes: [CONTROL_CLASS, 'cmp-video-wrapper__controls--volume'],
        },
        children: [
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--sound'] },
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--no-sound', 'cmp-button__icon--hidden'] },
        ],
        eventListeners: ['click'],
        callback: () => toggleVolume(this.videoPlayer, this.wrapperVolumeElement),
      }),
    )
  }
}
